import {HTTP} from '../../services/api-service.js';
import commonObj from '../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
// var tableName = 'BusinessEntity';

const orderStatusStore = {
    namespaced: true,
    state:{
        orderList: null
    },
    actions:{
        getOrderStatus({commit, state}, filter_condition) {
            return new Promise((resolve, reject) => {

                HTTP.post(baseUrl + '/SO/GetPendingSOList', filter_condition).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })

            })
        },
        getOrderStatusDetail({commit, state}, param) {
            return new Promise((resolve, reject) => {

                HTTP.post(baseUrl + '/SO/GetSO', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                })

            })
        },
    }
};
export default orderStatusStore;